export default "__VITE_ASSET__c6d20d93__"